import { ContainerType } from './ContainerType'
import { deepMerge } from '../utils'

export default class ContainerConfig {
  constructor (cfg) {
    this._cfg = deepMerge({
      type: 'SIMPLE',
      lazy_load: false
    }, cfg)
  }

  type () {
    return ContainerType[this._cfg.type]
  }

  /***
   * A CSS selector for any target ad unit containers if applicable
   * E.g. a css selector for all in-image pictures, or null for in place
   * @returns {*}
   */
  selector () {
    return this._cfg.selector
  }

  /**
   * @returns {boolean} True if container should have close buttons added
   */
  closeable () {
    return (this._cfg.closeable === true)
  }

  /**
   * Whether container should lazy load ad rendering
   * @returns {boolean}
   */
  lazyLoad (enable) {
    if (enable === undefined) {
      return this._cfg.lazy_load
    } else {
      this._cfg.lazy_load = enable
    }
  }
}
